import { useIntl } from 'react-intl';
import styled from '@emotion/styled/macro';

import DataGrid from '../../grid/DataGrid';
import StrategyGridWrapper from './StrategyGridWrapper';

import TableButton from './TableButton';

const BiddingStrategyTable = ({
    columns,
    className,
    isInitialRequestSent,
    noDataMessageId,
    rowData,
    columnSchema,
    disabled,
    shouldDisableButtons,
    ...rest
}) => {
    const intl = useIntl();

    const buttonGetter = (params) => {
        if (params.data === undefined) {
            return intl.formatMessage({ id: 'common_loading' });
        } else {
            const colId = Number(params.colDef.field);

            return params.data.genParticipationIds[colId];
        }
    };

    const monthNameGetter = (params) => {
        if (params.data === undefined) {
            return intl.formatMessage({ id: 'common_loading' });
        } else {
            return params.data.monthName;
        }
    };

    const columnTypes = {
        monthName: {
            valueGetter: monthNameGetter,
        },

        button: {
            cellRenderer: 'TableButton',
            cellRendererParams: { disabled: shouldDisableButtons },
            valueGetter: buttonGetter,
        },
    };

    return (
        <StrategyGridWrapper>
            {disabled && <InnerWrapper />}

            <DataGrid
                className={className}
                isInitialRequestSent={isInitialRequestSent}
                rowModelType="clientSide"
                noDataMessageId={noDataMessageId}
                groupDisplayType="groupRows"
                groupDefaultExpanded={-1}
                suppressContextMenu={true}
                columnTypes={columnTypes}
                frameworkComponents={{ TableButton }}
                headerHeight={44}
                rowHeight={44}
                defaultColDef={{
                    minWidth: 46,
                    flex: 1,
                    lockPosition: true,
                    editable: false,
                }}
                columnDefs={columns}
                suppressClipboardPaste={true}
                rowData={rowData}
                pagination={false}
                {...rest}
            />
        </StrategyGridWrapper>
    );
};

const InnerWrapper = styled.div`
    position: absolute;
    inset: 0;
    cursor: pointer;
    z-index: 9999;
`;

export default BiddingStrategyTable;
